module.exports = __webpack_public_path__ + "media/images/emblems/Le_Flon-coat_of_arms-00aba967a9358a4b0a1341abd6ed06b1.svg";